import React, { useState } from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

// 🔹 Helper to format dates like "25-Jul"
const formatDateDDMMM = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = String(date.getFullYear()).slice(-2); // last two digits

    return `${day}-${month}-${year}`;
};

// 🔹 Date Filter Helper
const getDateRange = (filter) => {
    const now = new Date();
    let start, end = new Date();

    switch (filter) {
        case 'Today':
            start = new Date(now.setHours(0, 0, 0, 0));
            end = new Date(now.setHours(23, 59, 59, 999));
            break;
        case 'This Week':
            start = new Date(now);
            start.setDate(start.getDate() - start.getDay());
            start.setHours(0, 0, 0, 0);
            end = new Date();
            end.setHours(23, 59, 59, 999);
            break;
        case 'Last Week':
            start = new Date(now);
            start.setDate(start.getDate() - start.getDay() - 7);
            start.setHours(0, 0, 0, 0);
            end = new Date(start);
            end.setDate(end.getDate() + 6);
            end.setHours(23, 59, 59, 999);
            break;
        case 'Last 15 Days':
            start = new Date();
            start.setDate(now.getDate() - 14);
            start.setHours(0, 0, 0, 0);
            end = new Date();
            end.setHours(23, 59, 59, 999);
            break;
        case 'This Month':
        default:
            start = new Date(now.getFullYear(), now.getMonth(), 1);
            end = new Date();
            end.setHours(23, 59, 59, 999);
            break;
    }

    return { startDate: start, endDate: end };
};

const DistributorActivitiesReport = () => {
    const [searchText, setSearchText] = useState('');
    const [dateFilter, setDateFilter] = useState('This Month');

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const apiStartDate = `${yyyy}-${mm}-01`;
    const apiEndDate = `${yyyy}-${mm}-${dd}`;

    const { data, error, isLoaded } = GetRequest(
        `/User/GetDistributorActivityReport/${apiStartDate}/${apiEndDate}`
    );

    if (error) return <Error data="Distributor Activity Summary" />;
    if (!isLoaded) return <Loading />;

    const activities = data.result || [];

    const { startDate, endDate } = getDateRange(dateFilter);

    const filteredData = activities.filter(item => {
        const matchesSearch = searchText.trim() === '' ||
            item.distributorName.toLowerCase().includes(searchText.toLowerCase());

        if (!item.lastActivityDate) {
            // Include distributors with no activity, but still match search
            return matchesSearch;
        }

        const lastActivityDate = new Date(item.lastActivityDate);
        const matchesDate = lastActivityDate >= startDate && lastActivityDate <= endDate;

        return matchesDate && matchesSearch;
    });


    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">Distributor Activities Summary</h5>
                            </div>

                            <div className="card-body pb-0">

                                <div className="row mb-3">
                                    <div className="col-md-6 mb-2">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search Distributor Name"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <table className="table table-bordered table-hover table-sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Distributor</th>
                                            <th className="text-center">Activity Count</th>
                                            <th>First Activity</th>
                                            <th>Last Activity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan="4" className="text-center text-muted">
                                                    No data found for selected filters.
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{item.distributorName}</td>
                                                    <td className="text-center">{item.activityCount}</td>
                                                    <td>{formatDateDDMMM(item.firstActivityDate)}</td>
                                                    <td>{formatDateDDMMM(item.lastActivityDate)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DistributorActivitiesReport;
